/* Coalesce identical concurrent Shopify cart reads without caching cart state. */
(function (scope) {
  'use strict';

  function requestUrl(input, origin) {
    try {
      return new URL(typeof input === 'string' ? input : input.url, origin);
    } catch (_error) {
      return null;
    }
  }

  function requestMethod(input, init) {
    return String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
  }

  function isCartMutation(url, method, origin) {
    return Boolean(
      url &&
      url.origin === origin &&
      method !== 'GET' &&
      /\/cart\/(?:add|change|update|clear)(?:\.js)?\/?$/.test(url.pathname),
    );
  }

  function isPlainCartRead(url, method, init, origin) {
    return Boolean(
      url &&
      url.origin === origin &&
      method === 'GET' &&
      !url.search &&
      !(init && init.body != null) &&
      /\/cart\.js$/.test(url.pathname),
    );
  }

  function createCartFetchCoalescer(baseFetch, origin) {
    var inFlight = new Map();
    var generation = 0;

    return function optimizedCartFetch(input, init) {
      var url = requestUrl(input, origin);
      var method = requestMethod(input, init);

      if (isCartMutation(url, method, origin)) {
        generation += 1;
        inFlight.clear();
        return baseFetch(input, init);
      }

      if (!isPlainCartRead(url, method, init, origin)) return baseFetch(input, init);

      var key = generation + ':' + url.href;
      var request = inFlight.get(key);
      if (!request) {
        request = Promise.resolve().then(function () { return baseFetch(input, init); });
        inFlight.set(key, request);
        request.then(
          function () {
            scope.setTimeout(function () {
              if (inFlight.get(key) === request) inFlight.delete(key);
            }, 0);
          },
          function () {
            if (inFlight.get(key) === request) inFlight.delete(key);
          },
        );
      }

      return request.then(function (response) { return response.clone(); });
    };
  }

  function install() {
    if (!scope.fetch || scope.fetch.__cdCartRequestCoalescer) return;
    var optimizedFetch = createCartFetchCoalescer(scope.fetch.bind(scope), scope.location.origin);
    optimizedFetch.__cdCartRequestCoalescer = true;
    scope.fetch = optimizedFetch;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { createCartFetchCoalescer: createCartFetchCoalescer };
  }

  if (typeof document !== 'undefined') install();
})(typeof window !== 'undefined' ? window : globalThis);
